// extracted by mini-css-extract-plugin
export var quantityInput = "_os-0";